import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";
import { DocumentModel } from "@models/documents/documentmodel";
import { CerrixPromptService } from "../services/cerrix-prompt.service";
import { firstValueFrom } from "rxjs";
import { DateTimeFormatPipe } from "@app/shared/pipes/date-time-format.pipe";
import { DocumentManagerComponent } from "../document-manager/document-manager.component";

@Component({
    selector: "cerrix-document-info-box-view",
    templateUrl: "./cerrix-document-info-box-view.component.html",
    styleUrls: ["./cerrix-document-info-box-view.component.scss"],
    imports: [NgTemplateOutlet, DateTimeFormatPipe, DocumentManagerComponent],
})
export class CerrixDocumentInfoBoxViewComponent {
    private promptService = inject(CerrixPromptService);

    @Input() infoBoxTitle: string;
    @Input() documents: DocumentModel[];

    @Input() allowAdd = false;
    @Input() allowEdit = false;
    @Input() allowDelete = false;

    @Output() onEdit = new EventEmitter<DocumentModel>();
    @Output() onDelete = new EventEmitter<DocumentModel>();
    @Output() onChange = new EventEmitter<DocumentModel[]>();

    private expandedDocuments = new Set<DocumentModel>();

    isExpanded(document: DocumentModel): boolean {
        return this.expandedDocuments.has(document);
    }

    toggleExpanded(document: DocumentModel) {
        if (this.expandedDocuments.has(document)) {
            this.expandedDocuments.delete(document);
        } else {
            this.expandedDocuments.add(document);
        }
    }

    get hasDocuments() {
        if (!this.documents) return false;
        if (this.documents.length === 0) return false;

        // Filter out "Deleted" documents and check if there are any left
        return this.documents.filter((x) => !x.Deleted).length > 0;
    }

    editDocument(document: DocumentModel) {
        this.onEdit.emit(document);
    }

    async deleteDocument(document: DocumentModel) {
        const result = await firstValueFrom(
            this.promptService
                .confirm(
                    "Delete document",
                    `Are you sure you want to delete document '${document.Name}' `
                )
                .getResult()
        );

        if (result) {
            this.onDelete.emit(document);
        }
    }

    documentsChanged(documents: DocumentModel[]) {
        this.onChange.emit(documents);
    }
}
